import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

export default function Copyright() {
    return (
      <Typography style={{ fontSize: '0.8em' }} align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://smti.portovelho.ro.gov.br/" target="_blank">
          Visite-nos
        </Link>{' '}
        {new Date().getFullYear()}
        {'. Versão 1.0'}
      </Typography>
    );
}